export type RechargeRedirectPendingRef = {
  current: boolean;
};

export function resetRechargeRedirectLoading(
  redirectPendingRef: RechargeRedirectPendingRef,
  setLoading: (loading: boolean) => void,
) {
  if (!redirectPendingRef.current) {
    return false;
  }

  redirectPendingRef.current = false;
  setLoading(false);
  return true;
}

export function observeRechargePageReturn(
  onReturn: () => void,
  windowTarget: Window = window,
  documentTarget: Document = document,
) {
  const handleVisibilityChange = () => {
    if (documentTarget.visibilityState === 'visible') {
      onReturn();
    }
  };

  windowTarget.addEventListener('pageshow', onReturn);
  documentTarget.addEventListener('visibilitychange', handleVisibilityChange);
  return () => {
    windowTarget.removeEventListener('pageshow', onReturn);
    documentTarget.removeEventListener(
      'visibilitychange',
      handleVisibilityChange,
    );
  };
}
